<div *ngIf="needed" class="progress-bar">
    <mat-progress-bar [mode]="mode" [value]="value"></mat-progress-bar>
</div>
<div *ngIf="!needed" class="progress-bar placeholder">&nbsp;</div>
